export const locale = {
    lang: 'en',
    data: {
        'AUTHENTICATION': {
            'INITIAL_TEXT': 'LOGIN TO YOUR ACCOUNT',
            'EMAIL': 'Email',
            'PASSWORD': 'Password',
            'FORGOT_PASSWORD': 'Forgot Password?',
            'LOGIN': 'LOGIN',
            'NO_ACCOUNT': 'Don\' have an account?',
            'CREATE_ACCOUNT': 'Create an account',
            'EMAIL_REQUIRED': 'Email is required',
            'INVALID_EMAIL': 'Please enter a valid email address',
            'PASSWORD_REQUIRED': 'Password is required',
            'WANT_VERIFY': 'Do you want to verify a document?',
            'DOCUMENT_VERIFICATION': 'Go to document verification'
        }
    }
};
